import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { IconChevronRight } from '@tabler/icons-react-native';
import { useScopedTranslation } from 'app/hooks/i18n';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { Pressable } from 'react-native';

export const MembersLink = ({
  addressId,
  isLoading,
  onPress,
  total,
}: {
  addressId: string | undefined;
  isLoading: boolean;
  onPress: () => void;
  total: number | undefined;
}) => {
  const { t } = useScopedTranslation();
  if (!addressId) return null;

  return (
    <Pressable onPress={onPress}>
      <Row
        alignItems="center"
        borderBottomWidth={1}
        borderColor="text.placeholder"
        borderTopWidth={1}
        flex={1}
        justifyContent="space-between"
        marginVertical="spacing.general.x4"
        paddingBottom="spacing.general.x1"
        paddingTop="spacing.general.x1"
      >
        <Row gap="spacing.general.x1">
          <Text color="text.brand" fontWeight="700">
            {t('viewMembersList')}
          </Text>
          <Text color="text.primary" fontWeight="400">
            {isLoading || total === undefined ? '-' : total}
          </Text>
        </Row>
        <IconChevronRight strokeWidth={ICON_STROKE_WIDTH} />
      </Row>
    </Pressable>
  );
};
